import React, { useState, useRef } from "react";
import { Layout, Typography, Button, Space, Grid } from "antd";
import { SoundOutlined } from "@ant-design/icons";

import MainHeader from "../components/layout/MainHeader";
import MainFooter from "../components/layout/MainFooter";
import "./BanhoDeOuroSemijoias.css";
import PorqueEscolher from "../components/components/porque_escolher/banho_ouro/porqueescolher";
import ComoFunciona from "../components/components/como_funciona/comoFunciona";
import ProofResultsSection from "../components/components/prova_social/ProofResultsSection";
import WhoWeServeSection from "../components/pra_quem-serve/WhoWeServeSection";
import FAQSection from "../components/components/FAQ/FAQSection.js";
import FloatingCTA from "../components/components/common/FloatingCTA.js";
import Reveal from "../components/components/common/Reveal.js";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

function BanhoDeOuroSemijoias() {
  const [muted, setMuted] = useState(true);
  const videoRef = useRef(null);

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const toggleAudio = () => {
    if (!videoRef.current) return;

    const nextMuted = !muted;
    videoRef.current.muted = nextMuted;

    videoRef.current
      .play()
      .catch((error) => console.log("Autoplay bloqueado:", error));

    setMuted(nextMuted);
  };

  return (
    <Layout>
      <MainHeader />
      <FloatingCTA triggerId="trigger-floating-cta" />

      <Content>
        <section className="section-banho-ouro">
          <div
            style={{
              maxWidth: 1400,
              margin: "0 auto",
              padding: isMobile ? "32px 16px 0" : "48px 20px 0",
            }}
          >
            <div
              style={{
                maxWidth: 980,
                margin: "0 auto",
                textAlign: "center",
                paddingBottom: isMobile ? 32 : 48,
              }}
            >
              <Reveal delay={200}>
                <Title
                  style={{
                    color: "#fff",
                    fontSize: "clamp(2.2rem, 5vw, 4.8rem)",
                    lineHeight: 1.05,
                    marginBottom: 20,
                  }}
                >
                  <span className="p-titulo">Banho de Ouro</span> para
                  Semijoias e Bijuterias com acabamento{" "}
                  <span className="p-titulo">premium</span>
                </Title>
              </Reveal>

              <Reveal delay={400}>
                <Paragraph
                  style={{
                    color: "#ffffffd9",
                    fontSize: isMobile ? 16 : 18,
                    lineHeight: 1.7,
                    maxWidth: 760,
                    margin: "0 auto 28px",
                  }}
                >
                  Serviço especializado para marcas e fabricantes que precisam
                  de brilho, uniformidade, controle técnico e padrão de
                  qualidade.
                </Paragraph>
              </Reveal>

              <Space
                wrap
                style={{
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Reveal delay={600}>
                  <Button
                    className="btn-ouro"
                    size="large"
                    onClick={() => {
                      window.dataLayer = window.dataLayer || [];

                      window.dataLayer.push({
                        event: "leads",
                        lead_source: "botao_solicitar_orcamento",
                        page_path: window.location.pathname,
                      });

                      window.open(
                        "https://wa.me/5511996064416?text=Olá!%20Tenho%20interesse%20nos%20serviços%20de%20banhos%20e%20vernizes%20para%20semijoias%20e%20gostaria%20de%20falar%20com%20um%20especialista.",
                        "_blank"
                      );
                    }}
                    style={{
                      width: isMobile ? "100%" : "auto",
                      maxWidth: isMobile ? 320 : "none",
                    }}
                  >
                    Solicitar orçamento
                  </Button>
                </Reveal>
              </Space>
            </div>

            {/* VIDEO */}
            <div
              style={{
                position: "relative",
                borderRadius: "24px 24px 0 0",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
                background: "#000",
              }}
            >
              <video
                ref={videoRef}
                autoPlay
                muted={muted}
                loop
                playsInline
                preload="auto"
                poster="/images/capa-video.jpg"
                style={{
                  width: "100%",
                  height: "clamp(260px, 52vw, 720px)",
                  objectFit: "cover",
                  display: "block",
                }}
              >
                <source src="/videos/homecompr.mp4" type="video/mp4" />
                Seu navegador não suporta vídeo.
              </video>

              {/* BOTÃO AUDIO */}
              <button
                onClick={toggleAudio}
                style={{
                  position: "absolute",
                  right: 16,
                  bottom: 16,
                  width: 42,
                  height: 42,
                  borderRadius: "50%",
                  border: "1px solid rgba(255,255,255,0.15)",
                  background: "rgba(0,0,0,0.6)",
                  backdropFilter: "blur(6px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "#d4b483",
                  zIndex: 2,
                }}
              >
                {muted ? "🔇" : <SoundOutlined />}
              </button>
            </div>
          </div>
        </section>

        <PorqueEscolher />

        <section id="trigger-floating-cta">
          <ComoFunciona />
        </section>

        {/* <ProofResultsSection /> */}

        <WhoWeServeSection />

        <FAQSection />
      </Content>

      <MainFooter />
    </Layout>
  );
}

export default BanhoDeOuroSemijoias;